import clsx from "clsx";
import { uuidv4 } from "../../helpers";
import { useMemo } from "react";

export type CheckboxProps = {
  label?: string;
  labelClassName?: string;
} & JSX.IntrinsicElements["input"];

export function Checkbox({
  label,
  className,
  disabled,
  labelClassName,
  children,
  ...rest
}: CheckboxProps) {
  // Kept unconditional: inlining this into the ternary below changes Hook order
  // when a caller adds or drops `id`.
  const generatedId = useMemo(() => uuidv4(), []);
  const id = rest.id ? rest.id : generatedId;
  return (
    <div
      className={clsx({
        "radio-checkbox": true,
        "radio-checkbox--disabled": disabled,
        [`${className}`]: className,
      })}>
      <input type="checkbox" {...rest} disabled={disabled} id={id} />
      {label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}
      {children}
    </div>
  );
}
